import React from 'react'
import {
  listTimelineRootVisions,
  type VisionTimelineRootCandidate,
} from '../services/visionService'

type UseTimelineRootVisionsForLinkResult = {
  items: VisionTimelineRootCandidate[]
  selected: VisionTimelineRootCandidate | null
  loading: boolean
  error: string | null
}

export function useTimelineRootVisionsForLink(
  enabled: boolean,
  selectedRootId: number | null,
  excludeVisionId: number | null,
): UseTimelineRootVisionsForLinkResult {
  const [items, setItems] = React.useState<VisionTimelineRootCandidate[]>([])
  const [loading, setLoading] = React.useState(false)
  const [error, setError] = React.useState<string | null>(null)

  const selected = React.useMemo(() => {
    if (!enabled) return null
    if (selectedRootId == null) return null
    const targetId = Number(selectedRootId)
    if (!Number.isFinite(targetId)) return null
    return items.find((it) => Number(it.id) === targetId) ?? null
  }, [enabled, items, selectedRootId])

  React.useEffect(() => {
    if (!enabled) {
      setItems([])
      setLoading(false)
      setError(null)
      return
    }

    let active = true
    setLoading(true)
    setError(null)

    listTimelineRootVisions()
      .then((rows) => {
        if (!active) return
        const excludeId =
          excludeVisionId != null && Number.isFinite(Number(excludeVisionId))
            ? Math.floor(Number(excludeVisionId))
            : null
        const filtered = excludeId
          ? (rows || []).filter((it) => Number(it.id) !== excludeId)
          : rows || []
        setItems(filtered)
      })
      .catch((e: any) => {
        if (!active) return
        setItems([])
        setError(e?.message || 'Falha ao carregar posts de timeline')
      })
      .finally(() => {
        if (!active) return
        setLoading(false)
      })

    return () => {
      active = false
    }
  }, [enabled, excludeVisionId])

  return { items, selected, loading, error }
}
